<template>
    <div class="stream-comment--wrapper">
        <h4 class="stream-comment--title">комментарии к подзадаче</h4>

        <div class="form-text stream-comment--window">
            <div
                class="stream-comment"
                v-for="comment in comments"
                :set="user = getUser(comment.userId)"
            >
                <div class="stream-comment__date">{{ toDate(comment.date) }}</div>
                <div class="stream-comment__user" :style="{color: userColor[user.id]}">
                    <span>{{ user.name }}</span>
                </div>
                <div class="stream-comment__text">{{ comment.text }}</div>
            </div>

            <p v-if="!comments.length && !isAccessAllow">комментариев нет</p>
        </div>

        <template v-if="isAccessAllow || current_user.id in common_users_list">
            <textarea
                class="form-text stream-comment--input"
                placeholder="текст комментария"
                v-model.trim="newCommentText"></textarea>

            <button
                class="stream-comment--submit btn btn-primary"
                @click.prevent="onSubmit"
                @keypress.enter="onSubmit"
            >Отправить</button>
        </template>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {colors} from "@common/utils/color";
import {dateToLeadingZeroObject} from "@common/utils/date";

export default {
    name: "streamComments",
    props: ['isAccessAllow'],
    data() {
        return {
            newCommentText: '',
        }
    },

    computed: {
        ...mapState({
            current_user: state => state.common.authUser,
            common_users_list: state => state.planUrlTask.users.reduce((accumulator, current) => {
                    accumulator[current.id] = {"id": current.id, "name": current.lastname + ' ' + current.firstname};
                    return accumulator;
                }, {}),
            users: state => state.planUrlTask.usersByIds,
            stream: state => state.planUrl.selectedStream,
            comments: state => state.planUrl.selectedStreamComments,
        }),

        /**
         * User to color relation.
         */
        userColor() {
            function arrayCombine(keys, values) {
                const obj = {};
                keys.forEach((key, idx) => obj[key] = values[idx]);

                return obj;
            }

            const userIds = Object.keys(this.users);
            return arrayCombine(userIds, userIds.map((userId, idx) => colors[idx % colors.length]));
        },
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('createPlanUrlComment', {
                stream: {
                    id: this.stream.id,
                    text: this.newCommentText,
                }
            });

            this.newCommentText = '';
        },
        getUser(userId) {
            return this.common_users_list[userId] || {};
        },
        toDate(date) {
            if (date instanceof Date) {
                const {days: d, months: m, years: y, hours: h, minutes: i} = dateToLeadingZeroObject(date);
                return `${d}.${m}.${y} ${h}:${i}`;
            }

            return '';
        },
    },
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.stream-comment {
    &--wrapper {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }

    &--title {
        margin: 0 0 10px;
        font-family: $headings-font-family;
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 27px;
        text-transform: uppercase;
        color: $primary;
    }

    &--window {
        max-height: 690px;
        flex: 1;
        padding: 12px;
        overflow-y: scroll;
        margin-bottom: 31px;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
    }

    &--input {
        width: 100%;
        height: 96px;
        min-height: 96px;
        margin: 0 0 10px;
    }

    &--submit {
        margin-right: auto;
    }
}
.stream-comment {
    margin-bottom: 10px;
    color: #6A6A6A;

    &__date {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 10px;
        line-height: 12px;
    }

    &__user {
        color: red;
    }

    &__text {
        overflow: auto;
        white-space: pre-line;
    }
}
</style>
